import { addMonths, differenceInDays } from 'date-fns';
import React from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { fetchDateRange } from '../utils/api/reports/analytics-requests';
import { DashboardChartHeader } from './components/chart-header';
import { DashboardDatePicker } from './components/dashboard-date-picker';
import { TimeRange } from '@nivo/calendar';

function formatData(data) {
  const returnData = {
    data: [],
    calendarRanges: {
      from: null,
      to: null,
    },
  };
  if (data && data.length > 0) {
    returnData.data = data.map((d) => ({
      day: d.date,
      value: d.count,
    }));
    returnData.calendarRanges.from = data[0].date;
    returnData.calendarRanges.to = data[data.length - 1].date;
    returnData.data = returnData.data.filter((d) => d.value > 0);
    // Because the colors are ugly if everything is 0, setting it to -1 chooses a better palette item.
    if (returnData.data.length === 0) {
      returnData.data = data.map((d) => ({
        day: d.date,
        value: -1,
      }));
    }
  }
  return returnData;
}

export function WorkflowsTriggeredCalendar(props) {
  const defaultDateRange = [addMonths(new Date(), -12), new Date()];
  const [dateRange, setDateRange] = React.useState(defaultDateRange);
  const [data, setData] = React.useState([]);
  const [dateRangeError, setDateRangeError] = React.useState('');
  const [showDatePicker, setShowDatePicker] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      if (!dateRange) {
        // If the date range is empty, force it to the default date range and do it again.
        setDateRange(defaultDateRange);
        return;
      }
      const daysDiff = differenceInDays(dateRange[1], dateRange[0]);
      if (daysDiff > 732) {
        setDateRangeError('Date range too large.  Please select a range of 2 years or less.');
        return;
      }
      setDateRangeError('');
      const jsonData = await fetchDateRange(
        props.reportClient,
        '/api/v1/analytics/workflows-triggered-counts',
        dateRange
      );
      const formattedData = formatData(jsonData);
      setData(formattedData);

      // We delay showing the datepicker until the rest of the UI is ready in order 
      // to avoid a snapping in the UI as it resizes itself.
      setShowDatePicker(true);
    })();
  }, [dateRange]);

  return (
    <div className="chart-box-flow">
      <div className="chart-box-flow-header">
        <DashboardChartHeader title="Workflow Activity" tooltip="Workflow activity heat map." />
        <DashboardDatePicker {...{ showDatePicker, dateRange, setDateRange, dateLocale: props.dateLocale }} />
      </div>
      {dateRangeError && <div className="ui message chart-date-error">{dateRangeError}</div>}
      <div className="chart-box-autosizer-wrapper">
        <AutoSizer>
          {({ width, height }) =>
            data?.data && (
              <TimeRange
                data={data.data}
                width={width}
                height={height}
                emptyColor="#f7fbff"
                colors={[
                  '#c6dbef',
                  '#9ecae1',
                  '#6baed6',
                  '#4292c6',
                  '#2171b5',
                  '#08519c',
                  '#08306b',
                ]}
                margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
                yearSpacing={40}
                monthBorderColor="#ffffff"
                dayBorderWidth={2}
                dayRadius={2}
                weekdayTicks={[0, 1, 2, 3, 4, 5, 6]}
                legends={[
                  {
                    anchor: 'bottom-right',
                    direction: 'row',
                    translateY: 36,
                    itemCount: 4,
                    itemWidth: 42,
                    itemHeight: 36,
                    itemsSpacing: 14,
                    itemDirection: 'right-to-left',
                  },
                ]}
              />
            )
          }
        </AutoSizer>
      </div>
    </div>
  );
}
